import { useAtom } from 'jotai';
import { selectedLeadsFilterAtom } from 'state/leadTableFiltering';

export const useSelectedLeadFilters = () => {
  const [selectedLeadFilters, setSelectedLeadFilters] = useAtom(selectedLeadsFilterAtom);

  return {
    selectedLeadFilters,
    setSelectedLeadFilters,
  };
};
